// import { useState } from 'react';

import { audioPlayerProgressRangeClassName } from '@components/AudioPlayer';
import { formatTime } from './helpers/formatTime';
import { TProps } from './types/TProps';

export const ProgressBar = ({ progressBarRef, seekTo, timeProgress, duration }: TProps) => {
  // const [seekableRange, setSeekableRange] = useState({ s: 0, e: 0, p: 0 });

  const handleProgressChange = () => {
    if (!progressBarRef?.current) {
      return;
    }
    seekTo(Number(progressBarRef.current.value));
  };

  return (
    <div className="progress flex min-w-0 flex-1 items-center justify-center gap-2.5">
      <div className="time whitespace-nowrap text-left text-sm font-normal leading-4 text-[var(--color-title)]">
        {formatTime(Math.floor(timeProgress))} / {formatTime(Math.floor(duration))}
      </div>
      <input
        className={`caret ${audioPlayerProgressRangeClassName}`}
        type="range"
        ref={progressBarRef}
        defaultValue="0"
        max={duration}
        onChange={handleProgressChange}
      />
      {/* <div className="caret-wrapper"> */}
      {/*  <div className="seekable" style={{ width: `${seekableRange.p}%` }}></div>*/}
      {/* </div> */}
    </div>
  );
};
